
/* eslint-disable */
// @ts-nocheck
// @ts-ignore

import * as srvoption from './srvoption.proto';
import * as rbac_common from './rbac_common.proto';
import * as im_common from './im_common.proto';


export const enum BotStatus {
  UNKNOWN = 0,
  ONLINE = 1,
  AUDITING = 2,
  AUDIT_FAIL = 3,
  OFFLINE = 4,
}

export const enum BotType {
  BotTypeUnknown = 0,
  BotTypeOfficial = 1,
  BotTypeDeveloper = 2,
}

export const enum BotPublicType {
  BotPublicTypeUnknown = 0,
  BotPublicTypePublic = 1,
  BotPublicTypePrivate = 2,
}

export const enum BotDisplayType {
  DisplayTypeUnknown = 0,
  DisplayTypeVoltron = 1,
  DisplayTypeH5 = 2,
}

export const enum BotServerNetworkType {
  NetworkTypeUnknown = 0,
  NetworkTypeTCP = 1,
  NetworkTypeUDP = 2,
}

export const enum BotServerProtocolType {
  ProtocolTypeUnknown = 0,
  ProtocolTypeHTTP = 1,
  ProtocolTypeTRPC = 2,
}

export const enum BotMsgOperType {
  OperTypeUnknown = 0,
  OperTypeUpdate = 1,
  OperTypeDelete = 2,
}

export const enum BotSwitchType {
  BotSwitchTypeUnknown = 0,
  BotSwitchTypeOpen = 1,
  BotSwitchTypeClose = 2,
}

export const enum BotOprTokenType {
  OprUnknown = 0,
  OprToken = 1,
  OprVerifyToken = 2,
  OprEncryptKey = 3,
  OprAppSecret = 4,
}

export const enum BotAdminStatus {
  BotAdminStatusUnknown = 0,
  BotAdminStatusPublished = 1,
  BotAdminStatusModified = 2,
  BotAdminStatusUnpublished = 3,
  BotAdminStatusDeleted = 4,
}

export const enum BotReceiveType {
  ReceiveTypeHigh = 0,
  ReceiveTypeAll = 1,
}

/** 机器人voltron配置 */
export interface DisplayVoltronConfig {
  /** voltron地址 */
  voltronUrl: string;
  /** md5 */
  voltronMd5: string;
  /** code 前端标识 */
  voltronCode: string;
}

/** 机器人h5配置 */
export interface DisplayH5Config {
  /** h5地址 */
  h5Url: string;
}

/** 机器人前端配置 */
export interface BotDisplayConfig {
  /** 类型，参见BotDisplayType */
  type: BotDisplayType;
  /** voltron配置 */
  voltronConfig: DisplayVoltronConfig;
  /** h5配置 */
  h5Config: DisplayH5Config;
}

/** 机器人服务器配置 */
export interface BotServerConfig {
  /** 后端服务的网络类型 tcp udp 配置优先 */
  network: BotServerNetworkType;
  /** 应用层协议 trpc http */
  protocol: BotServerProtocolType;
  /** 请求服务地址 */
  target: string;
  /** 请求最长处理时间 单位 毫秒 */
  timeout: string;
}

export interface BotInfo {
  /** BotID，即userID */
  id: string;
  /** Bot名称 */
  name: string;
  /** Bot头像 */
  avatar: string;
  /** 简介 */
  description: string;
  /** 创建时间 */
  createdTs: string;
  /** 修改时间 */
  modifiedTs: string;
  /** 开发者UID */
  createUid: string;
  /** 前端页面配置 */
  displayConfig: BotDisplayConfig;
  /** 标签分类(忽略) */
  tagList: Array<string>;
  /** 使用状态，参见BotStatus(忽略) */
  status: BotStatus;
  /** 类型，参见BotType */
  type: BotType;
  /** BOT所需授权ID */
  roleTplId: string;
  /** 模版权限 */
  ext: BotExtInfo;
  /** 开放类型 */
  publicType: BotPublicType;
  /** 是否显示免打扰按钮 */
  openMute: BotSwitchType;
  /** 开发者名称 */
  developerName: string;
}

export interface BotExtInfo {
  /** 权限列表 */
  perms: Array<rbac_common.Perms>;
}

export interface BotUpdateInfo {
  /** Bot名称 */
  name: string;
  /** Bot头像 */
  avatar: string;
  /** 简介 */
  description: string;
  /** 前端配置 */
  displayConfig: BotDisplayConfig;
  /** 服务器配置 */
  serverConfig: BotServerConfig;
  /** 标签分类 */
  tagList: Array<string>;
  /** 开放类型 */
  publicType: BotPublicType;
  /** BOT所需授权ID */
  roleTplId: string;
  /** 是否显示免打扰按钮 */
  openMute: BotSwitchType;
  /** 开发者名称 */
  developerName: string;
  /** 类型，参见BotType */
  type: BotType;
  /** 开发者UID */
  createUid: string;
}

export interface BotListInfo {
  /** Bot名称 */
  name: string;
  /** Bot头像 */
  avatar: string;
}

/** 指令分类 */
export interface CmdCategory {
  /** 分类ID */
  cateId: string;
  /** 名称 */
  name: string;
  /** 权重;权重越高排在越前 */
  score: string;
}

/** 指令分类 */
export interface CmdCategoryInfo {
  /** 名称 */
  name: string;
  /** 指令列表 */
  cmdList: Array<CmdInfo>;
  /** 分类ID */
  cateId: string;
}

/** 指令信息 */
export interface CmdInfo {
  /** 指令id */
  id: string;
  /** 名称 */
  name: string;
  /** 指令 */
  command: string;
  /** 参数列表 */
  paramList: Array<string>;
  /** 备注 */
  remark: string;
  /** 权重 */
  score: string;
  /** 是否限定管理员使用 */
  isAdmin: boolean;
  /** 用户是否能使用该指令 */
  canUse: boolean;
}

/** 机器人指令消息-KAFKA的消息结构 */
export interface BotCmdMsg {
  /** 机器人ID */
  botId: string;
  /** 指令id */
  cmdId: string;
  /** 操作类型 */
  operType: BotMsgOperType;
}

/** 官方机器人配置项 */
export interface BotGeneralConf {
  /** 是否自动欢迎 */
  isAutoWelcome: boolean;
  /** 是否自动送别 */
  isAutoFarewell: boolean;
  /** 自动欢迎频道ID */
  welcomeChannelId: string;
  /** 自动送别频道ID */
  farewellChannelId: string;
  /** 欢迎语列表 */
  welcomeMsgList: Array<string>;
  /** 送别语列表 */
  farewellMsgList: Array<string>;
  /** 不活跃自动分组开关 */
  inactiveSwitch: boolean;
  /** 不活跃时间 */
  inactiveTime: number;
  /** 不活跃分配的角色ID */
  inactiveRoleId: string;
  /** 是否自动踢人 */
  kickSwitch: boolean;
  /** 自动踢人时间 */
  kickTime: number;
  /** 自助管理数据推送开关 */
  manageSwitch: boolean;
  /** 自助管理数据推送频道ID */
  manageChannelId: string;
  /** 离群私聊通知开关 */
  farewellChatSwitch: boolean;
  /** 破冰问题开关 */
  questionSwitch: boolean;
  /** 主动聊天开关 */
  activeChatSwitch: boolean;
  /** 主动聊天频道ID */
  activeChatChannelId: string;
  /** 等级开关 */
  levelSwitch: boolean;
  /** 等级角色组开关 */
  levelRoleSwitch: boolean;
  /** 等级角色组开关 */
  levelNoticeSwitch: boolean;
}

/** BotId列表 */
export interface BotIdList {
  /** BotId列表 */
  botIdList: Array<string>;
}

export interface BotMsg {
  /** 普通消息/控制消息 */
  type: im_common.MsgType;
  /** 消息内容类型 */
  l2Type: im_common.MsgL2Type;
  /** 消息类型 */
  l3Types: Array<im_common.MsgL3Type>;
  /** 消息范围,单聊/channel/group */
  scope: im_common.MsgScope;
  /** 内部参数 */
  internalParams: im_common.InternalParameters;
}

export interface BotMsgCallback {
  /** im消息 */
  Msg: Array<BotMsg>;
}
